fx.ns("desktop.print", class Main extends shared.BaseMain {

	constructor() 
	{
		super(new repositories.PrintRepository());

        fx.set("app", "print"); 
	}

    init()
	{
		this.views = [  "desktop.common.screens.Splash",
						"desktop.common.screens.Saving",
						//"desktop.common.photoimport.AlbumsPhotos", 
						"desktop.common.photoimport.GooglePanel", 
						"desktop.common.photoimport.UploadProgress",
						//"desktop.common.screens.SuspendedBook",
						//"desktop.common.panels.InfoPanel",
						//"desktop.common.panels.SharedPhotosPanel",
						//"desktop.common.panels.CheckBookPanel",
						//"desktop.common.panels.ChangeThematicsPanel",
						//"desktop.common.panels.ChangeThemesPanel",
						//"desktop.common.panels.ProposePreviewPanel",
						"desktop.print.PrintEditor",
						"desktop.print.PhotoChoices"
					 ];

		this.on("TAB-DOWN", this._toggleGridMode, fx.keyboard);
	}


    onDataEvent(e)
	{
		super.onDataEvent(e);
		
		switch(e.type)
		{
			case "start":
				if (this.model.creationid)
					this.steps("Splash", "PrintEditor"); // ajouter editeur
				else
				{
                    fx.set("mode", "creating");
                    
					this.steps({view : "Splash", skipPrevious : true}, "PhotoChoices", "PrintEditor"); // ajouter editeur
				}
            break;

            case "import-pictures-panel" :
				this.popup(new desktop.common.photosimport.ImportPicturesPanel(this.model));
				break;

            case "edit-photo" :
				this.switchTo("EditPhoto", {photo : e.data, model : this.model});
				break;

            case "edit-text" :
				this.switchTo("EditText", {text : e.data, model : this.model});
				break;

            case "upload-progress":
				
				this.popup(new desktop.common.photoimport.UploadProgress(this.model));
				break;

            case "upload-finished" :
				if (this.actionRequested)
					this.model.event(this.actionRequested, 250);  // we add a delay to let time for updates
				break;

			case "import-google":
				this.popup(new desktop.common.photoimport.GooglePanel(this.model));
				break;

            case "order" :
				if(this.model.creation.numPrints < this.model.creation.minPages)
					this.popup(new common.popups.CheckPrints(fx.text("Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages", this.model.creation.minPages)));
				else if(this.model.creation.maxPages!=0 && (this.model.creation.numPrints>this.model.creation.maxPages))
					this.popup(new common.popups.CheckPrints(fx.text("Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages", this.model.creation.maxPages)));
				else if (this.readyLeaving(e.type))
					this.model.event("navigate-order", null, 500);
				break;

            case "exit-editor" :
				if (this.readyLeaving(e.type))
					this.model.event("navigate-exit", null, 500);
				break;

			case "selectphotos" :
				this.switchTo("PhotoChoices", e.detail);
				break;

			case "show-editor":
				this.actionRequested = ""
				this.switchTo("PrintEditor");
				break;

			
        }
    }

	_toggleGridMode(e)
	{
		fx.get("settings").toggleGridMode();
		
        e.stopPropagation();
		e.preventDefault();
	}
	
});